import { useEffect } from 'react';
import { applyRouteMetadata } from '../lib/seoMetadata';

export function RouteMetadata() {
  useEffect(() => {
    applyRouteMetadata(window.location.pathname);
  });

  return null;
}
